import Hero from '../components/Hero'
import Services from '../components/Services'
import WhyUs from '../components/WhyUs'
import Testimonials from '../components/Testimonials'
import ContactForm from '../components/ContactForm'
import { Link } from 'react-router-dom'

const Home = () => {
  return (
    <div className="min-h-screen">
      <Hero />

      {/* Why Choose Us */}
      <WhyUs />

      {/* Services */}
      <Services />

      {/* Testimonials */}
      <Testimonials />

      {/* Contact Form Section */}
      <section className="section-container bg-charcoal-900">
        <ContactForm />
      </section>
    </div>
  )
}

export default Home
